import { render, staticRenderFns } from "./PublicSelect.vue?vue&type=template&id=47fe3054&scoped=true&"
import script from "./PublicSelect.vue?vue&type=script&lang=js&"
export * from "./PublicSelect.vue?vue&type=script&lang=js&"
import style0 from "./PublicSelect.vue?vue&type=style&index=0&id=47fe3054&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47fe3054",
  null
  
)

export default component.exports